module.exports = __webpack_public_path__ + "img/bg.c1a49395.gif";